import { makeRequest } from '../../../lib/api';

const CLIENT_PATH = '/v1/clients';
const CLIENT_BONUS_PATH = '/v1/order_invoices/history_with_bonuses';
const CLIENT_ORDER_PATH = '/v1/order_fields';
// const CLIENT_INSURANCE_PATH = '/v1/insurance/vehicle_insurances';

class clientsController {
  findClientByPhone = (phoneNumber) => {
    return makeRequest('get', `${ CLIENT_PATH }/phone/${ phoneNumber }`);
  };

  getClient = (id) => {
    return makeRequest('get', `${ CLIENT_PATH }/${ id }`);
  };

  createClient = (data = {}) => {
    return makeRequest('post', `${ CLIENT_PATH }`, data);
  };

  updateClient = (data = {}) => {
    return makeRequest('put', `${ CLIENT_PATH }/${ data.id }`, data);
  };

  deleteClient = (clientId) => {
    return makeRequest('delete', `${ CLIENT_PATH }/${ clientId }`);
  };

  getClientInsuranceLosses = (id) => {
    return makeRequest('get', `${ CLIENT_PATH }/insurance_losses/${ id }`);
  };

  getClientServiceCards = (id) => {
    return makeRequest('get', `${ CLIENT_PATH }/service_cards/${ id }`);
  };

  findClientsByName = ({ firstName, lastName }) => {
    return makeRequest('get', `${ CLIENT_PATH }/search/name/?firstName=${ firstName }&lastName=${ lastName }`);
  };

  getBonusHistory = (clientId) => {
    return makeRequest('get', `${ CLIENT_BONUS_PATH }?clientId=${ clientId }`);
  };

  createClientBonus = (data = {}) => {
    return makeRequest('post', `${ CLIENT_PATH }/bonus_operation`, data);
  };

  getClientInsurances = (clientId) => {
    return makeRequest('get', `${ CLIENT_PATH }/insurances/${ clientId }?activityStatus=all`);
  };

  getClientFCMTokensList = (clientId) => {
    return makeRequest('get', `${ CLIENT_PATH }/fcm_tokens?clientId=${ clientId }`);
  };

  changeClient = (orderId, clientId) => {
    return makeRequest('post', `${ CLIENT_ORDER_PATH }/${ orderId }/change_client`, { clientId });
  };

}
export default new clientsController();
